import { EditIcon } from 'lucide-react';
import React, { useState } from 'react';
import { MdEdit } from "react-icons/md";

const InterestLocation = ({
  locations,
  onCreate,
  onUpdate,
  maxLocations,
  disableInput,
  loading,
}) => {
  const [inputValue, setInputValue] = useState('');
  const [editingLocation, setEditingLocation] = useState(null);

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleAddOrUpdate = () => {
    if (editingLocation) {
      onUpdate(editingLocation.id, inputValue);
      setEditingLocation(null);
    } else {
      onCreate(inputValue);
    }
    setInputValue('');
  };

  const handleEdit = (location) => {
    setEditingLocation(location);
    setInputValue(location.name);
  };

  const handleCancel = () => {
    setEditingLocation(null);
    setInputValue('');
  };

  return (
    <div className="mb-8">
      {/* Header and count */}
      <div className="flex justify-between items-center">
        <h1 className="text-xl font-bold">Interest Locations</h1>
        <span
          className={`text-sm ${
            locations.length >= maxLocations * 0.8 ? 'text-red-500' : 'text-gray-500'
          }`}
        >
          {locations.length}/{maxLocations} locations used
        </span>
      </div>

      {/* Locations and input */}
      <div className="flex gap-16 mt-4">
        {/* Existing locations */}
        <div className="custom-scrollbar overflow-x-hidden flex flex-wrap flex-auto w-7/12 h-64 rounded-md p-3 gap-x-2 gap-y-2 bg-appGrayBackground overflow-y-auto">
          {locations.map((item) => (
            <div
              key={item.id}
              className="bg-customGreen h-8 rounded-lg px-3 text-sm font-normal text-white mr-2 mb-2 flex items-center"
            >
              <span>{item.name}</span>
              <button
                className="ml-2 focus:outline-none"
                onClick={() => handleEdit(item)}
               
              >
                <MdEdit className="w-4 h-4 text-white" />
              </button>
            </div>
          ))}
        </div>

        {/* Input and actions */}
        <div className="flex flex-col w-5/12">
          <div className="flex gap-4 items-start">
            <div className="flex flex-col gap-1 max-w-md w-full">
              <input
                type="text"
                value={inputValue}
                onChange={handleInputChange}
                maxLength={50}
                placeholder="Enter interest location"
                className="px-4 py-2 h-10 text-sm rounded-md border border-gray-300 input-focus"
                disabled={disableInput && !editingLocation}
              />
              <div className="text-sm text-gray-500 mt-2">
                Add locations like: Chennai, Tambaram, Bangalore, Delhi, etc.
              </div>
            </div>
            <div className="flex gap-2">
              <button
                onClick={handleAddOrUpdate}
                disabled={(disableInput && !editingLocation) || loading}
                className={`h-10 px-4 text-sm font-medium rounded-md transition duration-200 ${
                  loading
                    ? 'text-gray-400 bg-gray-200 cursor-not-allowed'
                    : disableInput && !editingLocation
                    ? 'text-red-400 bg-red-100 cursor-not-allowed'
                    : 'text-white bg-customGreen'
                }`}
              >
                {loading ? 'Loading...' : editingLocation ? 'Update' : 'Add'}
              </button>

              {editingLocation && (
                <button
                  onClick={handleCancel}
                  className="h-10 px-4 text-sm font-medium rounded-md transition duration-200 text-white bg-gray-500 hover:bg-gray-600"
                >
                  Cancel
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InterestLocation;



// import React, { useCallback, useEffect, useState } from "react";
// import { IoIosAddCircleOutline, IoIosArrowForward } from "react-icons/io";
// import { MdSearch, MdDelete, MdClose } from "react-icons/md";
// import { CiEdit } from "react-icons/ci";
// import { Divider, getIcons, MenuItem } from "../../Constant/Constant";
// import interestLocationService from "../../Services/LocationService"; 
// import { userId, userUid } from "../../../utils/storage";
// import * as XLSX from "xlsx";
// import { LiaFileUploadSolid } from "react-icons/lia";
// import { showErrorToast, showSuccessToast } from "../../Constant/Notification";
// import ValidationModal from "../../shareableContainer/ValidationModal";

// const InterestLocation = () => {
//   const icons = getIcons();
//   const [menuOpen, setMenuOpen] = useState({});
//   const [modalOpen, setModalOpen] = useState({ manual: false, bulk: false, edit: false });
//   const [editingItem, setEditingItem] = useState(null);
//   const [locationName, setLocationName] = useState("");
//   const [multipleLocations, setMultipleLocations] = useState([]);
//   const [bulkData, setBulkData] = useState([]);
//   const [isProcessing, setIsProcessing] = useState(false);
//   const [validationErrors, setValidationErrors] = useState([]);
//   const [showValidationModal, setShowValidationModal] = useState(false);
//   const [insertedCount, setInsertedCount] = useState(0);
//   const [skippedCount, setSkippedCount] = useState(0);
//   const [skippedUnitsInfo, setSkippedUnitsInfo] = useState({
//     skippedCount: 0,
//     skippedUnitNos: [],
//   });
//   const [showSkippedModal, setShowSkippedModal] = useState(false);
//   const [selectedFile, setSelectedFile] = useState("");
//   const [searchTerm, setSearchTerm] = useState({
//     level_0: "",
//     level_1: "",
   
//   });
//   const [locations, setLocations] = useState({
//     level_0: [],
//     level_1: [],
   
//   });
//   const [selectedHierarchy, setSelectedHierarchy] = useState([]);

//   const maxSubLocations = 100;
//   const maxEnterLocations = 500;
//   const maxLevels = 2;

//   const handleToggle = (level) => {
//     setMenuOpen((prev) => ({
//       ...prev,
//       [level]: prev[level] === undefined ? true : !prev[level],
//     }));
//   };

//   const handleItemClick = (type, level) => {
//     setMenuOpen((prev) => ({ ...prev, [level]: false }));
//     setModalOpen({ manual: type === "Manual Upload", bulk: type === "Bulk Upload", edit: false });
//   };

//   const fetchLocations = async (level, parentId = null) => {
//     try {
//       let response;
//       if (level === "level_0") {
//         response = await interestLocationService.fetchMainData();
//         setLocations({
//           level_0: response?.data || [],
//           level_1: [],
//           level_2: [],
//           level_3: [],
//           level_4: [],
//         });
//       } else {
//         response = await interestLocationService.getSubLocation(parentId);
//         setLocations((prev) => ({
//           ...prev,
//           [level]: response?.data || [],
//         }));
//       }
//     } catch (error) {
//       console.error(`Error fetching ${level} locations:`, error);
//     }
//   };

//   useEffect(() => {
//     fetchLocations("level_0");
//   }, []);

//   const handleSelectItem = async (item, levelIndex) => {
//     const level = `level_${levelIndex}`;
    
   
//     if (selectedHierarchy[levelIndex]?.item.id === item.id) {
//       setSelectedHierarchy(selectedHierarchy.slice(0, levelIndex));
//       setLocations((prev) => {
//         const newSources = { ...prev };
//         for (let i = levelIndex + 1; i < maxLevels; i++) {
//           newSources[`level_${i}`] = [];
//         }
//         return newSources;
//       });
//       setSearchTerm((prev) => {
//         const newSearchTerm = { ...prev };
//         for (let i = levelIndex + 1; i < maxLevels; i++) {
//           newSearchTerm[`level_${i}`] = "";
//         }
//         return newSearchTerm;
//       });
//       return;
//     }

//     // Select the item
//     const newHierarchy = [...selectedHierarchy.slice(0, levelIndex), { level, item }];
//     setSelectedHierarchy(newHierarchy);

//     setLocations((prev) => {
//       const newSources = { ...prev };
//       for (let i = levelIndex + 1; i < maxLevels; i++) {
//         newSources[`level_${i}`] = [];
//       }
//       return newSources;
//     });

//     if (levelIndex < maxLevels - 1) {
//       const nextLevel = `level_${levelIndex + 1}`;
//       await fetchLocations(nextLevel, item.id);
//     }

//     setSearchTerm((prev) => {
//       const newSearchTerm = { ...prev };
//       for (let i = levelIndex + 1; i < maxLevels; i++) {
//         newSearchTerm[`level_${i}`] = "";
//       }
//       return newSearchTerm;
//     });
//   };

//   const handleAddMultipleLocations = async () => {
//     if (multipleLocations.length === 0) return;

//     const levelIndex = selectedHierarchy.length;
//     const level = `level_${levelIndex}`;
//     const parentId = levelIndex > 0 ? selectedHierarchy[levelIndex - 1].item.id : null;
//     const currentSources = locations[level] || [];

   
//     if (levelIndex === 0 && locations.level_0.length > 0) {
//       showErrorToast("Only one main location is allowed.");
//       return;
//     }

//     // Check sub-location limit
//     if (levelIndex > 0 && currentSources.length + multipleLocations.length > maxSubLocations) {
//       showErrorToast(`Cannot add more than ${maxSubLocations} sub-locations under this parent.`);
//       return;
//     }

//     setIsProcessing(true);
//     try {
//       const names = multipleLocations.map((item) => item.name);
//       const path = levelIndex > 0 ? selectedHierarchy.map((h) => h.item.id) : [];

//       const body = {
//         names,
//         parentNode: parentId,
//         isLeaf: path.length > 0 ? true : false,
//         path,
//         createdById: userUid,
//       };

//       console.log("Creating locations:", body);
//       const response = await interestLocationService.createLocation(body);
//       if (response.status === 200) {
//         showSuccessToast(response.data);
//       }
//       await fetchLocations(level, parentId);

//       setMultipleLocations([]);
//       setLocationName("");
//       setModalOpen({ manual: false, bulk: false, edit: false });
//     } catch (error) {
//       console.error("Error adding locations:", error);
//       showErrorToast("Failed to add locations. Please try again.");
//     } finally {
//       setIsProcessing(false);
//     }
//   };

//   const handleEditLocation = async () => {
//     if (!editingItem || !locationName.trim()) return;

//     const levelIndex = editingItem.path ? editingItem.path.length : 0;
//     const level = `level_${levelIndex}`;
//     const parentId = levelIndex > 0 ? editingItem.path[levelIndex - 1] : null;

//     setIsProcessing(true);
//     try {
//       const body = {
//         docId: editingItem.id,
//         name: locationName.trim(),
//         parentNode: editingItem.parentNode || null,
//         modifiedById: userUid,
//       };

//       console.log("Editing location:", body);
//       const response = await interestLocationService.editSubLocation(body);
//       if (response.status === 200) {
//         showSuccessToast(response.data);
//         setSelectedHierarchy([]);
//       }
//       await fetchLocations(level, parentId);

//       setEditingItem(null);
//       setLocationName("");
//       setModalOpen({ manual: false, bulk: false, edit: false });
//     } catch (error) {
//       console.error("Error editing location:", error);
//       showErrorToast("Failed to edit location. Please try again.");
//     } finally {
//       setIsProcessing(false);
//     }
//   };

//   const handleBulkUpload = (e) => {
//     const file = e.target.files[0];
//     const validFileTypes = [
//       "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//       "text/csv",
//     ];

//     if (file && !validFileTypes.includes(file.type)) {
//       showErrorToast("Invalid file type. Only .xlsx and .csv files are allowed.");
//       setSelectedFile("");
//       return;
//     }

//     setSelectedFile(file ? file.name : "");
//     if (!file) return;

//     const levelIndex = selectedHierarchy.length;
//     const level = `level_${levelIndex}`;
//     const currentSources = locations[level] || [];
//     const existingNames = currentSources.map((item) => item.name.toLowerCase());

//     const reader = new FileReader();
//     reader.onload = (event) => {
//       try {
//         const data = new Uint8Array(event.target.result);
//         const workbook = XLSX.read(data, { type: "array" });
//         const sheetName = workbook.SheetNames[0];
//         const worksheet = workbook.Sheets[sheetName];
//         const json = XLSX.utils.sheet_to_json(worksheet);

//         if (json.length > 500) {
//           showErrorToast("Only 500 rows are allowed in the uploaded file.");
//           setSelectedFile(null);
//           return;
//         }

//         const names = new Set();
//         const validLocations = [];
//         const duplicates = [];

//         json.forEach((entry, index) => {
//           const rawName = entry["Name"];
//           if (!rawName || typeof rawName !== "string" || !rawName.trim()) {
//             duplicates.push({
//               row: index + 2,
//               field: "Name",
//               message: "Missing or invalid name",
//             });
//             return;
//           }

//           const trimmed = rawName.trim();
//           const lowerName = trimmed.toLowerCase();

//           if (trimmed.length > 50) {
//             duplicates.push({
//               row: index + 2,
//               field: "Name",
//               message: "Name cannot exceed 50 characters",
//             });
//           } else if (names.has(lowerName)) {
//             duplicates.push({
//               row: index + 2,
//               field: "Name",
//               message: "Duplicate within uploaded file",
//             });
//           } else {
//             names.add(lowerName);
//             validLocations.push({
//               name: trimmed,
//               id: Date.now() + Math.random(),
//             });
//           }
//         });

//         if (duplicates.length > 0) {
//           setValidationErrors(duplicates);
//           setShowValidationModal(true);
//           setSelectedFile(null);
//           showErrorToast("Some entries are invalid. Please review.");
//           return;
//         }

//         setBulkData(validLocations);
//       } catch (error) {
//         console.error("Error parsing Excel file:", error);
//         showErrorToast("Failed to parse the uploaded file.");
//         setSelectedFile(null);
//       }
//     };

//     reader.readAsArrayBuffer(file);
//   };

//   const handleBulkSubmit = async () => {
//     if (bulkData.length === 0) return;

//     const levelIndex = selectedHierarchy.length;
//     const level = `level_${levelIndex}`;
//     const parentId = levelIndex > 0 ? selectedHierarchy[levelIndex - 1].item.id : null;
//     const currentSources = locations[level] || [];

//     // Check if main location already exists at level_0
//     if (levelIndex === 0 && locations.level_0.length > 0) {
//       showErrorToast("Only one main location is allowed.");
//       return;
//     }

//     // Check sub-location limit
//     if (levelIndex > 0 && currentSources.length + bulkData.length > maxSubLocations) {
//       showErrorToast(`Cannot add more than ${maxSubLocations} sub-locations under this parent.`);
//       return;
//     }

//     setIsProcessing(true);
//     try {
//       const names = bulkData.map((item) => item.name);
//       const path = levelIndex > 0 ? selectedHierarchy.map((h) => h.item.id).slice(0, -1) : [];

//       const body = {
//         names,
//         parentNode: parentId,
//         isLeaf: levelIndex === maxLevels - 1,
//         path,
//         createdById: userUid,
//       };

//       console.log("Bulk uploading locations:", body);
//       const response = await interestLocationService.createLocation(body);
//       if (response.status === 200) {
//         showSuccessToast("Bulk upload completed successfully!");
//         setShowSkippedModal(true);
//         setInsertedCount(response?.data?.insertedCount);
//         setSkippedUnitsInfo({
//           skippedCount: response.data.skippedCount,
//           skippedUnitNos: response.data.skippedNames || [],
//         });
//       }
//       await fetchLocations(level, parentId);

//       setBulkData([]);
//       setSelectedFile("");
//       setModalOpen({ manual: false, bulk: false, edit: false });
//     } catch (error) {
//       console.error("Error during bulk upload:", error);
//       showErrorToast("Error during bulk upload. Please try again.");
//     } finally {
//       setIsProcessing(false);
//     }
//   };

//   const addToMultipleList = () => {
//     if (
//       locationName.trim() &&
//       !multipleLocations.find(
//         (item) => item.name.toLowerCase() === locationName.trim().toLowerCase()
//       )
//     ) {
//       const levelIndex = selectedHierarchy.length;
//       const level = `level_${levelIndex}`;
//       const currentSources = Array.isArray(locations[level]) ? locations[level] : [];

//       const existingNames = currentSources.map((item) => item.name.toLowerCase());
//       if (existingNames.includes(locationName.trim().toLowerCase())) {
//         showErrorToast(`Location name "${locationName.trim()}" already exists at this level.`);
//         return;
//       }

//       if (multipleLocations.length >= maxEnterLocations) {
//         showErrorToast(`Locations not allowed more than ${maxEnterLocations}`);
//         return;
//       }

//       setMultipleLocations([
//         ...multipleLocations,
//         { name: locationName.trim(), id: Date.now() + Math.random() },
//       ]);
//       setLocationName("");
//     }
//   };

//   const removeFromMultipleList = (id) => {
//     setMultipleLocations(multipleLocations.filter((item) => item.id !== id));
//   };

//   const getCurrentLevelName = () => {
//     const levelIndex = selectedHierarchy.length;
//     if (levelIndex === 0) return "Main Location";
//     return `Sub Location`;
//   };

//   const getParentHierarchy = () => {
//     return selectedHierarchy.map((h) => h.item.name).join(" > ");
//   };

//   const filteredLocations = (level) => {
//     const sourceList = locations[level] || [];
//     if (!Array.isArray(sourceList)) {
//       console.warn(`Expected an array for locations[${level}], but got:`, sourceList);
//       return [];
//     }
//     const term = searchTerm[level]?.toLowerCase() || "";
//     return sourceList.filter((item) => item.name?.toLowerCase().includes(term));
//   };

//   const renderLocationColumn = (levelIndex) => {
//     const level = `level_${levelIndex}`;
//     const hasParentSelected = levelIndex === 0 || selectedHierarchy[levelIndex - 1];
//     const items = filteredLocations(level);
//     const parentItem = selectedHierarchy[levelIndex - 1]?.item;
//     const isLastLevel = levelIndex === maxLevels - 1;
//     const isCurrentLevelSelected = !!selectedHierarchy[levelIndex];

//     // Disable adding new main location if one already exists
//     const canAddNew = levelIndex === 0 ? items.length === 0 : hasParentSelected && !isCurrentLevelSelected;

//     return (
//       <section
//         key={level}
//         className="bg-white relative border h-[calc(100vh-270px)] overflow-hidden w-[402px] border-gray-300 p-4 rounded-[10px]"
//       >
//         <div className="flex items-center justify-between mb-4">
//           <div className="flex flex-col gap-1 w-[70%]">
//             <div className="text-customGreen truncate font-semibold">
//               {levelIndex === 0 ? `Main Location (${items.length})` : `Sub Location (${levelIndex})`}
//             </div>
//             {parentItem && (
//               <div className="flex items-center gap-1">
//                 <div className="truncate">{parentItem?.name}</div>
//                 <span>({items.length})</span>
//               </div>
//             )}
//           </div>
//           {canAddNew && (
//             <div className="relative">
//               <div
//                 className="bg-customGreen rounded flex items-center gap-1 text-white cursor-pointer p-1"
//                 onClick={() => handleToggle(level)}
//               >
//                 <IoIosAddCircleOutline className="text-white text-xl font-bold" />
//                 <div className="text-sm">Add New</div>
//               </div>
//               {menuOpen[level] && (
//                 <div className="absolute right-0 mt-4 w-64 bg-white rounded-xl shadow-lg z-10">
//                   <div className="absolute -top-2 rounded right-4 w-4 h-4 bg-white rotate-45"></div>
//                   <div className="py-2">
//                      <MenuItem
//                                           onClick={() => handleItemClick("Manual Upload", level)}
//                                           icon={icons.leadSourceManualIcon}
//                                           label="Manual Upload"
//                                         />
//                                         <Divider />
//                                         <MenuItem
//                                           onClick={() => handleItemClick("Bulk Upload", level)}
//                                           icon={icons.leadSourceBulkIcon}
//                                           label="Bulk Upload"
//                                         />
//                   </div>
//                 </div>
//               )}
//             </div>
//           )}
//         </div>

//         <div className="relative mb-4">
//           <MdSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
//           <input
//             type="text"
//             placeholder="Search"
//             value={searchTerm[level] || ""}
//             onChange={(e) =>
//               setSearchTerm((prev) => ({ ...prev, [level]: e.target.value }))
//             }
//             className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-customGreen"
//           />
//         </div>

//         <div className="mt-3 h-[calc(93vh-270px)] pb-20 overflow-y-auto custom-scrollbar">
//           {items.length > 0 ? (
//             items.map((item) => (
//               <div
//                 key={item.id}
//                 onClick={() => handleSelectItem(item, levelIndex)}
//                 className={`flex flex-col border-2 ${
//                   selectedHierarchy[levelIndex]?.item.id === item.id
//                     ? "border-customGreen"
//                     : "border-slate-200"
//                 } p-3 rounded-md mb-3 gap-2 cursor-pointer hover:bg-gray-100`}
//               >
//                 <div className="flex items-center justify-between">
//                   <div title={item.name} className="flex-1 cursor-pointer truncate w-[80%]">
//                     {item.name}
//                   </div>
//                   <div className="flex items-center gap-2">
//                     <button
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         setEditingItem(item);
//                         setLocationName(item.name);
//                         setModalOpen({ manual: false, bulk: false, edit: true });
//                       }}
//                       className="text-gray-500 hover:text-customGreen"
//                     >
//                       <CiEdit size={18} />
//                     </button>
//                     {!isLastLevel && (
//                       <IoIosArrowForward
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           handleSelectItem(item, levelIndex);
//                         }}
//                         className="text-gray-500 hover:text-customGreen cursor-pointer"
//                       />
//                     )}
//                   </div>
//                 </div>
//               </div>
//             ))
//           ) : (
//             <div className="text-center text-gray-500 py-4">
//               {hasParentSelected ? (
//                 <div className="flex flex-col gap-2 justify-center items-center">
//                   <img src={icons.emptyLeadSourceIcon} alt="Empty" /> {/* Adjusted icon */}
//                   <div>No Location</div>
//                 </div>
//               ) : (
//                 <div className="flex flex-col gap-2 justify-center items-center">
//                   <img src={icons.emptyLeadSourceIcon} alt="Empty" /> {/* Adjusted icon */}
//                   <div>Select a {levelIndex === 0 ? "main" : `level ${levelIndex - 1}`} location first</div>
//                 </div>
//               )}
//             </div>
//           )}
//         </div>
//       </section>
//     );
//   };

//   const handleCancel = () => {
//     setMultipleLocations([]);
//     setLocationName("");
//     setBulkData([]);
//     setSelectedFile("");
//     setModalOpen({ manual: false, bulk: false, edit: false });
//     setEditingItem(null);
//   };

//   const handleDownloadTemplate = useCallback(() => {
//     const link = document.createElement("a");
//     link.href = "/Sample Interest and Locations.xlsx"; // Adjusted file name
//     link.setAttribute("download", "Sample-template Interest and Locations.xlsx");
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   }, []);

//   const BulkUploadModal = () => (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
//       <div className="bg-white p-6 rounded-lg w-full max-w-2xl max-h-[90vh] overflow-y-auto">
//         <div className="flex justify-between items-center mb-6 bg-slate-100 p-2 rounded-md">
//           <h2 className="text-lg font-medium text-customGreen">
//             Bulk Upload {getCurrentLevelName()}
//           </h2>
//           <button
//             onClick={() => {
//               setBulkData([]);
//               setSelectedFile("");
//               setModalOpen({ manual: false, bulk: false, edit: false });
//             }}
//             className="text-red-600 bg-white px-2 rounded-full p-1"
//           >
//             <MdClose size={20} />
//           </button>
//         </div>

//         {selectedHierarchy.length > 0 && (
//           <div className="text-sm text-gray-600 mb-4">
//             Parent Hierarchy: {getParentHierarchy()}
//           </div>
//         )}

//         <div className="space-y-4 mb-6">
//           <div className="flex justify-between items-center">
//             <label htmlFor="file-upload" className="text-lg font-medium text-gray-700">
//               Attach File (Excel/CSV)
//             </label>
//             <button
//               onClick={handleDownloadTemplate}
//               className="flex items-center gap-2 text-sm text-customGreen hover:underline"
//             >
//               <LiaFileUploadSolid className="w-4 h-4" />
//               Download Template
//             </button>
//           </div>
//           <label htmlFor="file-upload" className="block cursor-pointer">
//             <div className="relative border border-gray-300 hover:border-gray-400 transition rounded-lg px-4 py-3 text-gray-600 bg-gray-50">
//               <span className="flex items-center gap-2">
//                 <LiaFileUploadSolid className="w-6 h-6 text-customGreen" />
//                 <span>{selectedFile || "Click to select a file (.xlsx, .csv)"}</span>
//               </span>
//               <input
//                 id="file-upload"
//                 type="file"
//                 accept=".xlsx,.csv"
//                 onChange={handleBulkUpload}
//                 className="absolute inset-0 opacity-0 cursor-pointer"
//               />
//             </div>
//           </label>
//         </div>

//         <div className="flex justify-end gap-3">
//           <button
//             onClick={() => {
//               setBulkData([]);
//               setSelectedFile("");
//               setModalOpen({ manual: false, bulk: false, edit: false });
//             }}
//             className="h-10 px-4 text-sm font-medium rounded-md transition duration-200 text-white bg-gray-500 hover:bg-gray-600"
//           >
//             Cancel
//           </button>
//           <button
//             onClick={handleBulkSubmit}
//             disabled={bulkData.length === 0 || isProcessing}
//             className="h-10 px-4 text-sm font-medium rounded-md transition duration-200 bg-customGreen text-white hover:bg-green-700 disabled:bg-gray-300"
//           >
//             {isProcessing ? "Uploading..." : "Upload"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );

//   return (
//     <main className="p-4">
//       <div className="flex gap-4 items-center h-screen overflow-x-auto custom-scrollbar pipeline pb-2">
//         <div className="flex items-center gap-7">
//           {[...Array(maxLevels)].map((_, index) => (
//             <React.Fragment key={`level_${index}`}>
//               {renderLocationColumn(index)}
//               {index < maxLevels - 1 && (
//                 <img src={icons.leadSourceArrow} className="h-7 w-7" alt="arrow" /> 
//               )}
//             </React.Fragment>
//           ))}
//         </div>
//       </div>

//       {modalOpen.manual && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
//           <div className="bg-white p-6 rounded-lg w-[1300px] max-h-[90vh] overflow-y-auto">
//             <div className="flex justify-between items-center mb-4">
//               <h1 className="text-xl font-bold">
//                 Add {getCurrentLevelName()}
//                 {selectedHierarchy.length > 0 && (
//                   <span className="text-sm text-gray-500 ml-2">
//                     (Under {getParentHierarchy()})
//                   </span>
//                 )}
//               </h1>
//               <span className="text-sm text-gray-500">
//                 {selectedHierarchy.length === 0
//                   ? `${multipleLocations.length}/1 main location used`
//                   : `${multipleLocations.length}/${maxEnterLocations} sub-locations used`}
//               </span>
//             </div>

//             <div className="flex gap-12 mt-4">
//               <div className="custom-scrollbar overflow-x-hidden flex flex-wrap flex-auto w-[40%] h-64 rounded-md p-3 gap-x-2 gap-y-2 bg-gray-100 overflow-y-auto">
//                 {multipleLocations.map((item) => (
//                   <div
//                     key={item.id}
//                     className="bg-customGreen h-8 rounded-lg px-3 text-sm font-normal text-white mr-2 mb-2 flex items-center"
//                   >
//                     <span>{item.name}</span>
//                     <button
//                       className="ml-2 focus:outline-none"
//                       onClick={() => removeFromMultipleList(item.id)}
//                     >
//                       <MdDelete className="w-4 h-4 text-white" />
//                     </button>
//                   </div>
//                 ))}
//               </div>

//               <div className="flex flex-col w-5/12">
//                 <div className="flex gap-4 items-start">
//                   <div className="flex flex-col gap-1 max-w-lg w-full">
//                     <input
//                       type="text"
//                       value={locationName}
//                       onChange={(e) => setLocationName(e.target.value)}
//                       onKeyPress={(e) => e.key === "Enter" && addToMultipleList()}
//                       maxLength={50}
//                       placeholder={`Enter ${getCurrentLevelName().toLowerCase()}`}
//                       className="px-4 py-2 h-10 text-sm rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-customGreen"
//                     />
//                     <div className="text-sm text-gray-500 mt-2">
//                       Add locations like: New York, Manhattan, etc. Press Enter or click 'Add to List'.
//                     </div>
//                   </div>
//                   <div className="flex gap-2 flex-wrap">
//                     <button
//                       onClick={addToMultipleList}
//                       disabled={!locationName.trim()}
//                       className="h-10 w-full text-nowrap px-4 text-sm font-medium rounded-md transition duration-200 bg-customGreen text-white disabled:bg-gray-300"
//                     >
//                       Add to List
//                     </button>
//                     <button
//                       onClick={handleAddMultipleLocations}
//                       disabled={multipleLocations.length === 0 || isProcessing}
//                       className="h-10 px-4 w-full text-nowrap text-sm font-medium rounded-md transition duration-200 bg-customGreen text-white disabled:bg-gray-300"
//                     >
//                       {isProcessing ? "Processing..." : `Create All (${multipleLocations.length})`}
//                     </button>
//                     <button
//                       onClick={handleCancel}
//                       className="h-10 px-4 w-full text-sm font-medium rounded-md transition duration-200 text-white bg-gray-500 hover:bg-gray-600"
//                     >
//                       Cancel
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {modalOpen.bulk && <BulkUploadModal />}
//       {modalOpen.edit && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
//           <div className="bg-white p-6 rounded-lg w-[600px] max-h-[90vh] overflow-y-auto">
//             <div className="flex bg-slate-100 p-2 rounded-md justify-between items-center mb-6">
//               <h1 className="text-xl font-semibold text-customGreen">
//                 Edit {editingItem.path ? `Sub Location` : "Main Location"}
//               </h1>
//               <button
//                 onClick={handleCancel}
//                 className="text-red-600 bg-white px-2 rounded-full p-1"
//               >
//                 <MdClose size={20} />
//               </button>
//             </div>

//             <div className="flex flex-col gap-4">
//               <input
//                 type="text"
//                 value={locationName}
//                 onChange={(e) => setLocationName(e.target.value)}
//                 maxLength={50}
//                 placeholder="Enter location name"
//                 className="px-4 py-2 h-10 text-sm rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-customGreen"
//               />
//               <div className="text-sm text-gray-500">
//                 Update the location name and click 'Update' to save changes.
//               </div>
//               <div className="flex justify-end gap-3">
//                 <button
//                   onClick={handleCancel}
//                   className="h-10 px-4 text-sm font-medium rounded-md transition duration-200 text-white bg-gray-500"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={handleEditLocation}
//                   disabled={!locationName.trim() || isProcessing}
//                   className="h-10 px-4 text-sm font-medium rounded-md transition duration-200 bg-customGreen text-white disabled:bg-gray-300"
//                 >
//                   {isProcessing ? "Processing..." : "Update"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//       <ValidationModal
//         show={showValidationModal}
//         onClose={() => setShowValidationModal(false)}
//         errors={validationErrors}
//       />
//       {showSkippedModal && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
//           <div className="bg-white p-4 rounded-xl shadow-xl w-full max-w-md overflow-hidden">
//             <div className="flex bg-slate-100 p-2 rounded-md justify-between items-center mb-6">
//               <h2 id="bulk-upload-title" className="text-lg font-medium text-green-700">
//                 Duplicate Locations Found
//               </h2>
//               <button
//                 onClick={() => setShowSkippedModal(false)}
//                 className="text-red-600 bg-white focus:outline-none rounded-full p-2"
//                 aria-label="Close modal"
//               >
//                 <svg
//                   className="w-5 h-5"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                   xmlns="http://www.w3.org/2000/svg"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth="2"
//                     d="M6 18L18 6M6 6l12 12"
//                   />
//                 </svg>
//               </button>
//             </div>

//             <div className="">
//               <div className="grid grid-cols-2 gap-4 mb-6">
//                 <div className="bg-green-5 border text-center border-green-100 rounded-lg p-3">
//                   <div className="text-green-800 font-medium text-sm">Successful</div>
//                   <div className="text-2xl font-bold text-green-600">{insertedCount}</div>
//                   <div className="text-green-500 text-xs">locations inserted</div>
//                 </div>
//                 <div className="bg-yellow-0 border text-center border-yellow-100 rounded-lg p-3">
//                   <div className="text-yellow-800 font-medium text-sm">Skipped</div>
//                   <div className="text-2xl font-bold text-yellow-600">{skippedUnitsInfo.skippedCount}</div>
//                   <div className="text-yellow-500 text-xs">duplicate locations</div>
//                 </div>
//               </div>

//               <div className="mb-4">
//                 <h3 className="text-sm font-medium text-gray-700 mb-2 flex items-center">
//                   <svg className="w-4 h-4 mr-1 text-yellow-500" fill="currentColor" viewBox="0 0 20 20">
//                     <path
//                       fillRule="evenodd"
//                       d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
//                       clipRule="evenodd"
//                     />
//                   </svg>
//                   Duplicate locations found:
//                 </h3>
//                 <div className="border border-gray-200 rounded-lg overflow-hidden">
//                   <div className="max-h-48 overflow-y-auto">
//                     <table className="min-w-full divide-y divide-gray-200">
//                       <thead className="bg-gray-50">
//                         <tr>
//                           <th
//                             scope="col"
//                             className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
//                           >
//                             Location Name
//                           </th>
//                         </tr>
//                       </thead>
//                       <tbody className="bg-white divide-y divide-gray-200">
//                         {skippedUnitsInfo.skippedUnitNos.map((unitNo, index) => (
//                           <tr key={index} className="hover:bg-gray-50">
//                             <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-700">
//                               {unitNo}
//                             </td>
//                           </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               </div>

//               <div className="flex justify-end pt-4 border-t border-gray-200">
//                 <button
//                   onClick={() => setShowSkippedModal(false)}
//                   className="px-6 py-2 bg-customGreen text-white rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
//                 >
//                   Done
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </main>
//   );
// };

// export default InterestLocation;

